<div class="marine-insurance-quote-pricing" [ngClass]="{ 'is-with-margin-top': isWithMarginTop }">
  <div class="marine-insurance-quote-pricing-body">
    <div class="row">
      <div class="col-12 col-xl-8">
        <div class="marine-insurance-quote-pricing-body-details">
          <h3 class="marine-insurance-quote-pricing-body-details-header">
            {{ headerText | translate }}
          </h3>

          <app-marine-insurance-quote-view-data [marineInsurance]="marineInsurance"></app-marine-insurance-quote-view-data>

          <p class="marine-insurance-quote-pricing-body-details-hint">
            {{ "INSURANCE_QUOTE_BASED_ON_THE_INFORMATION_PROVIDED" | translate }}
          </p>

          <div class="marine-insurance-quote-pricing-body-details-footer">
            <div class="marine-insurance-quote-pricing-body-details-footer-terms-link" (click)="isShowTerms ? hideTerms() : showTerms()">
              {{ "LEARN_MORE_TERMS_OF_COVERAGE" | translate }}

              <img class="ml-2" src="/assets/icons/icon_chevron_down_gray.svg" />
            </div>

            <button
              type="button"
              class="btn btn-link d-print-none marine-insurance-quote-pricing-body-details-footer-edit-btn"
              [disabled]="disabled"
              (click)="edit.emit()"
            >
              <img src="assets/icons/icon_edit_dark_gray.svg" />

              <span class="ml-1">{{ "BUTTON.EDIT" | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4 pl-xl-0">
        <app-marine-insurance-payment-breakdown [pendingBills]="pendingBills"></app-marine-insurance-payment-breakdown>

        <p class="mt-1 mb-1" *ngIf="isPaymentPending">{{ "YOUR_FILING_IS_ON_HOLD" | translate }}</p>

        <div class="w-100 text-center">
          <button
            type="button"
            class="btn btn-primary mt-2"
            [disabled]="disabled"
            [routerLink]="['/marine-insurance', parent?.referenceNumber]"
          >
            <span class="d-flex align-items-center">
              {{ "COVER_MY_SHIPMENT" | translate }}

              <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="marine-insurance-quote-pricing-footer" *ngIf="isShowTerms">
      <div class="row">
        <div class="col-12">
          <div class="marine-insurance-quote-pricing-footer-header">
            <h5 class="marine-insurance-quote-pricing-footer-header-text">{{ "COVERAGE_DETAILS" | translate }}</h5>

            <span class="marine-insurance-quote-pricing-footer-header-close" (click)="hideTerms()">
              <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
              <span>{{ "BUTTON.CLOSE" | translate }}</span>
            </span>
          </div>

          <app-marine-insurance-terms-data></app-marine-insurance-terms-data>
        </div>
      </div>
    </div>
  </div>
</div>
